import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "child-list-header sticky top-[50px] w-full mb-3 z-10 bg-background-strongest min-h-[47px]" }
const _hoisted_2 = {
  key: 0,
  class: "child-lists flex pl-3"
}

import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import useSwimlanes from '../../boards/composables/useSwimlanes';
import BoardListHeader from './BoardListHeader.vue';
import BoardList from './BoardList.vue';
import HorizontalRule from '../sections/settings/HorizontalRule.vue';
import AddNewCardButton from './AddNewCardButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SwimlanesList',
  props: {
  listId: {
    type: String,
    required: true,
  },
  mainListIds: {
    type: Array as () => string[],
    required: true,
  },
  position: {
    type: Number,
    required: false,
    default: 0,
  },
  containerWidth: {
    type: Number,
    required: false,
    default: 0,
  },
  emptyMainLists: {
    type: Array,
    required: false,
    default: () => [],
  },
  allListCards: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  subGroupCards: {
    type: Object,
    required: false,
    default: () => ({}),
  },
},
  emits: ['update:height'],
  setup(__props, { emit: __emit }) {

const { boardSubGroupBy, showStatusIconPickerSubGroup, currentBoardId, hideEmptyGroups } =
  useSwimlanes();

const store = useStore();

const emits = __emit;

const addCard = ref('');

const props = __props;

const listExpanded = computed(() => {
  return store.getters.getListExpanded(currentBoardId.value, props.listId);
});

const listCards = computed(() => {
  return props.allListCards.subGroups?.[props.listId] ?? [];
});

const isUnassignedListId = (listId: string | number) => {
  return listId === `${currentBoardId.value}-unassigned`;
};

// Check if main list is in the emptyMainLists array
const isMainListEmpty = (mainListId: string) => {
  return props.emptyMainLists.includes(mainListId);
};

const isEmptyGroup = computed(() => {
  return hideEmptyGroups.value && !listCards.value.length;
});

const visibleListIds = ref<string[]>([]);

const addVisibleListId = (listId: string) => {
  if (!visibleListIds.value.includes(listId)) {
    visibleListIds.value.push(listId);
  }
};

const removeVisibleListId = (listId: string) => {
  const index = visibleListIds.value.indexOf(listId);
  if (index > -1) {
    visibleListIds.value.splice(index, 1);
  }
};

const childListContent = ref<HTMLElement | null>(null);
const heightTimeout = ref<NodeJS.Timeout | null>(null);

onMounted(() => {
  heightTimeout.value = setTimeout(() => {
    const height = childListContent.value?.getBoundingClientRect().height;
    emits('update:height', height ?? 0);
    heightTimeout.value = null;
  }, 100);
});
onUnmounted(() => {
  if (heightTimeout.value) {
    clearTimeout(heightTimeout.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_observe_visibility = _resolveDirective("observe-visibility")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "childListContent",
    ref: childListContent,
    class: _normalizeClass(["child-list-content flex flex-col", {
      'empty-group': isEmptyGroup.value,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BoardListHeader, {
        "list-id": props.listId,
        "header-footer-style": {},
        expandable: true,
        "show-status-icon-picker": _unref(showStatusIconPickerSubGroup) || isUnassignedListId(props.listId),
        "disable-status-icon-picker": true,
        "group-by": _unref(boardSubGroupBy),
        "list-cards": listCards.value,
        visible: true,
        "is-cards-layout-timeline": false,
        "is-epic-board": false,
        class: "mb-1 sticky left-0"
      }, null, 8, ["list-id", "show-status-icon-picker", "group-by", "list-cards"]),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createVNode(HorizontalRule, { class: "ml-3" })
    ]),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (listExpanded.value && !isEmptyGroup.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mainListIds, (parentList, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["child-list-cards min-w-[274px] flex flex-col overflow-auto", {
          'empty-group': isMainListEmpty(parentList),
        }])
            }, [
              (
            (__props.subGroupCards?.[parentList]?.[__props.listId]?.cardIds?.length > 0 &&
              (index < 9 || visibleListIds.value.includes(String(parentList)))) ||
            addCard.value === `${parentList}-${__props.listId}`
          )
                ? (_openBlock(), _createBlock(BoardList, {
                    key: 0,
                    ref_for: true,
                    ref: `boardList-${props.listId}`,
                    visible: true,
                    "list-id": props.listId,
                    "parent-list-id": parentList,
                    index: index,
                    "large-board": false,
                    "group-by": _unref(boardSubGroupBy),
                    expandable: true,
                    position: __props.position,
                    "container-width": __props.containerWidth,
                    "sprint-disable-drag": true,
                    "show-add-card-button": true,
                    "show-list-header": false,
                    "sub-group-cards": __props.subGroupCards?.[parentList]?.[__props.listId]?.cardIds,
                    onHideCreateCardView: _cache[0] || (_cache[0] = ($event: any) => (addCard.value = ''))
                  }, null, 8, ["list-id", "parent-list-id", "index", "group-by", "position", "container-width", "sub-group-cards"]))
                : _createCommentVNode("", true),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (
            __props.subGroupCards?.[parentList]?.[__props.listId]?.cardIds?.length === 0 &&
            addCard.value !== `${parentList}-${__props.listId}` &&
            (index < 9 || visibleListIds.value.includes(String(parentList)))
          )
                ? (_openBlock(), _createBlock(AddNewCardButton, {
                    key: 1,
                    "list-id": __props.listId,
                    "parent-list-id": parentList,
                    class: "mt-1",
                    onAddCardClick: ($event: any) => (addCard.value = `${parentList}-${__props.listId}`)
                  }, null, 8, ["list-id", "parent-list-id", "onAddCardClick"]))
                : _createCommentVNode("", true)
            ], 2)), [
              [_directive_observe_visibility, {
          callback: (isVisible) => {
            if (isVisible) {
              addVisibleListId(String(parentList));
            } else {
              removeVisibleListId(String(parentList));
            }
          },
        }]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})